<template>
  <div v-if="page" class="pt-3 pb-16" :class="page.alias ? `page-alias-${page.alias}` : undefined">
    <UContainer v-if="!startsWithBanner" class="max-w-189">
      <Breadcrumb :items="page.breadcrumb" class="mb-4 lg:mb-6" />
      <h1 class="font-poppins text-28 lg:text-4xl font-semibold leading-9 lg:leading-12 text-brand-dark-blue mb-6">{{ page.name }}</h1>
    </UContainer>

    <DynamicPageContent v-if="Array.isArray(page?.content)" :content="page.content" />
    <UContainer v-else>
      <SafeHtml :html="page?.content" class="prose" />
    </UContainer>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
    page: any
}>()

const startsWithBanner = computed(() =>
    Array.isArray(props.page?.content) && props.page.content[0]?.type === 'banner'
)
</script>